import Model from "../_model";

export default class ContainerProductModel extends Model {
	constructor(provider) {
		super(provider, "shipments/{shipmentId}/containers/{containerId}/products");
	}

	_getUrl(shipmentId, containerId, id) {
		let url = this.apiMethod.replace("{shipmentId}", shipmentId).replace("{containerId}", containerId);
		return id ? url.concat(`/${id}`) : url;
	}

	_createBody(instance) {
		return {
			productId: instance.productId,
			variantId: instance.variantId,
			unitCode: instance.unitCode,
			name: instance.name,
			quantity: instance.quantity,
			amount: instance.amount,
			lines: instance.lines || [],
		};
	}

	create(shipmentId, containerId, instance, { onSuccess, onFail }) {
		return super.create(this._createBody(instance), {
			url: this._getUrl(shipmentId, containerId),
			onSuccess,
			onFail,
		});
	}

	update(shipmentId, containerId, instance, { onSuccess, onFail }) {
		return super.update(
			{ ...this._createBody(instance), id: instance.id },
			{
				url: this._getUrl(shipmentId, containerId, instance.id),
				onSuccess,
				onFail,
			}
		);
	}

	delete(shipmentId, containerId, id, { onSuccess, onFail }) {
		return super.delete({
			url: this._getUrl(shipmentId, containerId, id),
			onSuccess,
			onFail,
		});
	}
}
